module.exports = __webpack_public_path__ + "img/closed-loop-5.3f8cef0f.png";